import React from "react";

const Support = () => {
  return <div>Under Construction this page.</div>;
};

export default Support;
